import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, MISC } from '@const'
import * as utils from '@utils'
import { Grid, Button, FormControlLabel, Checkbox, InputAdornment } from '@material-ui/core'
import { TextField, Select } from '@prototype'
import { DatetimeSelect, PfSubPfMultiSelect, GameMultiSelect, DateBasicSelect } from '@select'
import MaterialTable from 'material-table'
import { Edit, Delete } from '@material-ui/icons'
import { EventDragonTigerAwardsDialog, UploadActivityImgDialog } from '@dialogs'
import { ConfirmMsgDialog } from '@msg'
import GiveFreeGame from './giveFreeGame'
import { Icon, Table, Input, Modal, Spin, Form } from 'antd';
import { Decimal } from 'decimal.js'
import Editor from '.././../editor/editor'
import moment from 'moment'

const defaultSelectForGame = ['SlotJump', 'SlotBlissComes', 'SlotFaceChanging', 'SlotPrehistoricElephant', 'Slot777', 'SlotKingKong', 'SlotWildfireRanger', 'SlotDouble777', 'SlotSplash', 'SlotDragonBoatFestival', 'SlotTreasure', 'SlotQixiFestival', 'SlotJumpHigh', 'SlotMoonFestivalParty', 'SlotGemMine', 'SlotChristmasGift', 'SlotSuperAce']
const initialState = {
    name: '',
    dialogType: 'add',
    type: MISC.EVENT_RED_PACKET,
    redPacketTableData: [],
    redPacketThreshold: '',
    dragonTableData: [],
    dragonThreshold: 0,
    tigerTableData: [],
    tigerThreshold: 0,
    confirmBtnDisable: false,
    dialogOpen: false,
    totalMoneyTitle: 'totalMoney',
    enableMaxGachaPacket: false,
    enableMaxAwardThreshold: false,
    maxGachaPacket: 0,
    maxAwardThreshold: 0,
    dragonTigerEditData: [],
    dragonTigerEditType: '',
    dragonTigerEditDialog: false,
    dragonTigerEditDialogType: 'add',
    valid: false,
    eventInfo: {},
    subPfSelectDisabledList: [],
    gameSelectDisabledList: [],
    freeGameSelectDisabledList: [],
    loading: false,
    // 抽紅包相關
    redPacketStartDate: '', //抽紅包預告開始日期
    redPacketEndDate: '',
    accumulationStartDate: '',
    accumulationEndDate: '',
    redemptionDeadlineDate: '',
    eventRedemptionStatus: '',
    redPacketSelectTitle: 'setting',
    redPacketStatus: 'true',
    activitySetting: {
        'CHS': '',
        'ENU': '',
        'VIE': '',
        'THA': '',
        'ESP': '',
        'PTE': '',
    },
    redPacketList: [
        [
            {
                listIndex: 0,
                tableKey: '0'
            }
        ]
    ],
    redPacketImageData: {
        CHS: null,
        ENU: null,
        VIE: null,
        THA: null,
        ESP: null,
        PTE: null,
    },
    eventID: '',
    redPacketIsExpired: false,
    demoStage: 0,
    currency: '',
    redPacketIsStart: false,
    redPacketGameType: MISC.EVENT_RED_PACKET,
    isCopy: false,
    template: 'LuckyWheel',
    redPacketDefaultSelectForGame: []
}

const tableConfig = {
    options: {
        search: false,
        pageSize: 7,
        showTitle: false,
        actionsColumnIndex: -1,
        pageSizeOptions: [10, 30, 50, 100],
    },
    localization: {
        header: { actions: 'actions' },
        body: {
            emptyDataSourceMessage: '',
            editRow: {
                deleteText: 'confirm',
                cancelTooltip: '',
                saveTooltip: '',
            },
            addTooltip: '',
            editTooltip: '',
            deleteTooltip: '',
        },
        pagination: {
            firstTooltip: '',
            previousTooltip: '',
            nextTooltip: '',
            labelDisplayedRows: '{from}-{to} / {count}',
            lastTooltip: '',
        },
    },
}

function rankDragonTigerTableData(tableData) {
    return tableData
        .sort((a, b) => b['money'] - a['money'])
        .map((elem, idx) => {
            elem.rank = idx + 1
            return elem
        })
}

class EventDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EventDialog', options)
        }
        this.state = initialState
        this.defaultSelectForGame = defaultSelectForGame

        this.translateUI()
    }

    actions = [
        {
            text: '',
            icon: 'edit',
            onClick: (_evt, data) => {
                this.setState({
                    dragonTigerEditData: data,
                }, () => {
                    this.handleOpenDragonTigerDialog('edit', data[0].type)
                })
            },
        },
        {
            text: '',
            icon: 'delete',
            onClick: (_evt, data) => {
                this.handleDragonTigerDelete(data, data[0].type)
            },
        }
    ]
    dragonTigerBoardTableColumns = [
        { title: 'money', field: 'money', type: 'numeric' },
        { title: 'rank', field: 'rank', type: 'numeric', editable: 'never' },
        {
            title: utils.t('actions'),
            headerStyle: { 'textAlign': 'center' },
            sorting: false,
            render: (rowData) => {
                return (
                    <div style={{ textAlign: 'center' }}>
                        <Edit
                            className={this.props.classes.actionsBtn}
                            onClick={() => {
                                this.setState({
                                    dragonTigerEditData: [rowData],
                                }, () => {
                                    this.handleOpenDragonTigerDialog('edit', rowData.type)
                                })
                            }}
                        />
                        <Delete
                            className={this.props.classes.actionsBtn}
                            onClick={() => {
                                this.handleDragonTigerDelete([rowData], rowData.type)
                            }}
                        />
                    </div>
                )
            }
        }
    ]
    translateUI() {
        this.dragonTigerBoardTableColumns.forEach((elem) => (elem.title = this.t(elem.title)))
        tableConfig.localization.header.actions = this.t('actions')
        tableConfig.localization.body.editRow.deleteText = this.t('confirm')
    }

    componentDidMount() {
        this.props.onRef(this)
        utils.apiRequest(  // 僅紅包的遊戲列表需要另外call api
            'get',
            API.EVENT_GANE_LIST,
            {},
            (data) => {
                this.setState({
                    redPacketDefaultSelectForGame: data.map((item) => item.game_code)
                })
            }
        )
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    OpenDialog(dialogType, eventID, eventType, isCopy = false) {
        const platformsNotSupportEventsList = utils.getPlatformsNotSupportEvents()
        if (dialogType === 'edit') {
            switch (eventType) {
                case MISC.EVENT_RED_PACKET:
                    utils.apiRequest(
                        'get',
                        API.RED_PACKET_DETAIL,
                        {
                            event_id: eventID,
                        },
                        (data) => {
                            const activitySetting = Object.keys(this.state.activitySetting).reduce((value, key) => {
                                value[key] = data.description.find((item) => item.language === key)?.description
                                return value
                            }, {})

                            const stage = data.stage.reduce((value, item, index) => {
                                delete item.id
                                const data = item.bonus_list.map((bonusItem) => {
                                    bonusItem.listIndex = index
                                    bonusItem.tableKey = `${bonusItem.stage_id}.${bonusItem.id}`
                                    const cloneItem = Object.assign({ ...bonusItem }, item)
                                    delete cloneItem.bonus_list
                                    delete cloneItem.created_at
                                    delete cloneItem.updated_at
                                    return cloneItem
                                })
                                value.push(data)
                                return value
                            }, [])

                            this.setState(
                                {
                                    name: data.name,
                                    type: MISC.EVENT_RED_PACKET,
                                    dialogOpen: true,
                                    confirmBtnDisable: false,
                                    redPacketStatus: String(data.is_active),
                                    activitySetting: activitySetting,
                                    redPacketThreshold: data.budget,
                                    redPacketList: stage,
                                    redPacketImageData: data.image.img_url,
                                    eventRedemptionStatus: String(data.redeemable),
                                    redPacketIsExpired: data.is_expired,
                                    demoStage: data.demo_stage,
                                    redPacketIsStart: utils.isDateAfter(utils.getCurrentUTCMoment(), utils.getMoment(data.cumulative_start_at)) && !this.state.isCopy,
                                    eventID: eventID,
                                    dialogType: isCopy ? 'add' : dialogType,
                                    isCopy,
                                    subPfSelectDisabledList: platformsNotSupportEventsList
                                },
                                () => {
                                    setTimeout(() => {
                                        this.redPacketpfSelect.setState({
                                            currency: data.currency,
                                            pfSubPfIDList: data.joined_sub_pf_list
                                        })
                                        this.redPacketStartDate.setState({
                                            endDate: utils.unixToDateTime(data.start_at)
                                        })
                                        this.redPacketEndDate.setState({
                                            endDate: utils.unixToDateTime(data.end_at)
                                        })
                                        this.accumulationStartDate.setState({
                                            endDate: utils.unixToDateTime(data.cumulative_start_at)
                                        })
                                        this.accumulationEndDate.setState({
                                            endDate: utils.unixToDateTime(data.cumulative_end_at)
                                        })
                                        this.redemptionDeadlineDate.setState({
                                            endDate: utils.unixToDateTime(data.redemption_end_at)
                                        })
                                        this.redPacketGameSelect.setState({
                                            gameList: data.joined_game_code_list
                                        })
                                        this.setState({
                                            currency: data.currency
                                        })
                                    })
                                    this.handleTableStyle()
                                    this.handleTableRender()
                                }
                            )
                        },
                        (_err) => { },
                        true
                    )
                    break
                case MISC.EVENT_DRAGON_TIGER_BOARD:
                    utils.apiRequest(
                        'get',
                        API.DRAGON_TIGER_BOARD_DETAIL,
                        {
                            event_id: eventID,
                        },
                        (data) => {
                            const eventInfo = data
                            const dragonTableData = []
                            data['dragon_awards'].forEach((elem) => {
                                dragonTableData.push({
                                    money: elem,
                                    isNew: false,
                                    type: 'dragon'
                                })
                            })
                            const tigerTableData = []
                            data['tiger_awards'].forEach((elem) => {
                                tigerTableData.push({
                                    money: elem,
                                    isNew: false,
                                    type: 'tiger'
                                })
                            })

                            this.setState(
                                {
                                    name: eventInfo['event_name'],
                                    type: MISC.EVENT_DRAGON_TIGER_BOARD,
                                    dragonTableData: rankDragonTigerTableData(dragonTableData),
                                    dragonThreshold: eventInfo['dragon_threshold'],
                                    tigerTableData: rankDragonTigerTableData(tigerTableData),
                                    tigerThreshold: eventInfo['tiger_threshold'],
                                    eventInfo: eventInfo,
                                    confirmBtnDisable: false,
                                    dialogOpen: true,
                                    dialogType: dialogType,
                                    subPfSelectDisabledList: platformsNotSupportEventsList
                                },
                                () => {
                                    this.updateTableColumnTitle(eventInfo['currency'])
                                    setTimeout(() => {
                                        this.pfSelect.setState({
                                            currencyDisabled: true,
                                            currency: eventInfo['currency'],
                                            pfSubPfIDList: eventInfo['joined_sub_pf_list'],
                                            pfSubPfListDisabled: false,
                                        })
                                        this.datetimeSelect.setState({
                                            startDisabled: true,
                                            endDisabled: eventInfo['is_expired'],
                                            startDate: utils.unixToDateTime(eventInfo['start_at']),
                                            endDate: utils.unixToDateTime(eventInfo['end_at']),
                                        })
                                        this.gameSelect.setState({
                                            gameList: eventInfo['joined_game_code_list'],
                                        })
                                    })
                                }
                            )
                        },
                        (_err) => { },
                        true
                    )
                    break
                default:
                    utils.apiRequest(
                        'get',
                        API.GIVE_FREE_GAME_DETAIL,
                        {
                            event_id: eventID,
                        },
                        (data) => {
                            const eventInfo = data
                            this.setState(
                                {
                                    name: eventInfo['name'],
                                    type: MISC.EVENT_GIVE_FREE_GAME,
                                    eventInfo,
                                    confirmBtnDisable: false,
                                    dialogOpen: true,
                                    dialogType,
                                    subPfSelectDisabledList: eventInfo['joined_sub_pf_list'],
                                    gameSelectDisabledList: eventInfo['joined_game_code_list'],
                                    freeGameSelectDisabledList: eventInfo['play_game_code_list']
                                },
                                () => {
                                    setTimeout(() => {
                                        this.pfSelect.setState({
                                            currencyDisabled: true,
                                            currency: eventInfo['currency'],
                                            pfSubPfIDList: eventInfo['joined_sub_pf_list']
                                        })
                                        this.datetimeSelect.setState({
                                            startDisabled: true,
                                            endDisabled: eventInfo['is_expired'],
                                            startDate: utils.unixToDateTime(eventInfo['start_at']),
                                            endDate: utils.unixToDateTime(eventInfo['end_at']),
                                        })
                                        this.gameSelect.setState({
                                            gameList: eventInfo['joined_game_code_list'],
                                        })
                                        this.freeGameSelect.setState({
                                            gameList: eventInfo['play_game_code_list'],
                                        })
                                        this.setState({
                                            currency: eventInfo['currency']
                                        })
                                    })
                                }
                            )
                        },
                        (_err) => { },
                        true
                    )
                    break
            }
        } else if (dialogType === 'add') {
            this.setState(
                {
                    ...JSON.parse(JSON.stringify(initialState)),
                    dialogOpen: true,
                    dialogType,
                    subPfSelectDisabledList: platformsNotSupportEventsList
                },
                () => {
                    setTimeout(() => {
                        this.datetimeSelect.setState({
                            startDate: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day').add(1, 'days'),
                            endDate: utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day').add(2, 'days'),
                        })

                        this.redPacketStartDate.setState({
                            endDate: utils.momentToUTCString(utils.currentDatetime())
                        })
                        this.redPacketEndDate.setState({
                            endDate: utils.momentToUTCString(utils.currentDatetime())
                        })
                        this.accumulationStartDate.setState({
                            endDate: utils.momentToUTCString(utils.currentDatetime())
                        })
                        this.accumulationEndDate.setState({
                            endDate: utils.momentToUTCString(utils.currentDatetime())
                        })
                        this.redemptionDeadlineDate.setState({
                            endDate: utils.momentToUTCString(utils.currentDatetime())
                        })
                        this.redPacketGameSelect.setState({
                            gameList: []
                        })
                        this.redPacketpfSelect.setState({
                            currency: this.redPacketpfSelect.state.currencyList[0],
                            pfSubPfIDList: []
                        })
                        this.setState({
                            currency: this.redPacketpfSelect.state.currencyList[0]
                        })
                    })
                    this.handleTableStyle()
                    this.handleTableRender()
                }
            )
        }
    }

    updateTableColumnTitle() {
        this.dragonTigerBoardTableColumns.find((elem) => elem.field === 'money').title = this.t('money', { currency: `(${this.t('gameCurrency')})` })

        this.setState({
            redPacketTableData: this.state.redPacketTableData,
            dragonTableData: this.state.dragonTableData,
            tigerTableData: this.state.tigerTableData
        })
    }

    closeDialog(needConfirm = true) {
        const initState = () => {
            this.setState({
                subPfSelectDisabledList: [],
                gameSelectDisabledList: [],
                freeGameSelectDisabledList: [],
                dialogOpen: false,
                confirmBtnDisable: false,
                loading: false,
                ...JSON.parse(JSON.stringify(initialState)),
            }, () => {
                this.confirmDialog.closeDialog()
            })
        }

        if (needConfirm) {
            this.confirmDialog.OpenDialog({
                type: 'warn',
                msg: this.t('noSaveLeave'),
                confirm: (_params) => {
                    initState()
                },
            })
        } else {
            initState()
        }
    }

    enableConfirmBtn() {
        this.setState({
            confirmBtnDisable: false,
            loading: false
        })
    }

    disableConfirmBtn() {
        this.setState({
            confirmBtnDisable: true,
            loading: true
        })
    }

    handleNameValid() {
        let valid = false
        valid = Boolean(this.state.name.trim())
        return valid
    }

    handleDateValid(key) {
        const redPacketStartDate = this.redPacketStartDate.state.endDate
        const redPacketEndDate = this.redPacketEndDate.state.endDate
        const accumulationStartDate = this.accumulationStartDate.state.endDate
        const accumulationEndDate = this.accumulationEndDate.state.endDate
        const redemptionDeadlineDate = this.redemptionDeadlineDate.state.endDate

        const role = {
            accumulationStartBeforeRedPacketStart: moment(accumulationStartDate).isBefore(moment(redPacketStartDate)) ||
                moment(accumulationStartDate).isSame(moment(redPacketStartDate)),
            accumulationEndBeforeAccumulationStart: moment(accumulationEndDate).isBefore(moment(accumulationStartDate)) ||
                moment(accumulationEndDate).isSame(moment(accumulationStartDate)),
            redemptionDeadlineBeforeAccumulationEnd: moment(redemptionDeadlineDate).isBefore(moment(accumulationEndDate)) ||
                moment(redemptionDeadlineDate).isSame(moment(accumulationEndDate)),
            accumulationEndAfterRedPacketEnd: moment(accumulationEndDate).isAfter(moment(redPacketEndDate)) ||
                moment(accumulationEndDate).isSame(moment(redPacketEndDate))
        }

        let valid = true
        valid = !role[key]
        return valid
    }

    getRedPacketFormData() {
        const isEdit = this.state.dialogType === 'edit'
        const stage = JSON.parse(JSON.stringify(this.state.redPacketList)).reduce((value, item) => {
            const data = {
                consume_points: Number(item[0].consume_points || ''), // 合併直列col所以直接拿第一個就好
                fake_min_bonus: Number(item[0].fake_min_bonus || ''),
                fake_max_bonus: Number(item[0].fake_max_bonus || ''),
                is_demo: item[0].is_demo || false,
                bonus_list: item.map((bonusItem) => {
                    bonusItem.max_bonus = Number(bonusItem.max_bonus || '')
                    bonusItem.min_bonus = Number(bonusItem.min_bonus || '')
                    bonusItem.total_quantity = Number(bonusItem.total_quantity || '')
                    bonusItem.winning_probability = Number(bonusItem.winning_probability || '')
                    delete bonusItem.consume_points
                    delete bonusItem.fake_max_bonus
                    delete bonusItem.fake_min_bonus
                    delete bonusItem.listIndex
                    delete bonusItem.is_demo
                    if (this.state.isCopy) {
                        delete bonusItem.event_id
                        delete bonusItem.id
                        delete bonusItem.stage_id
                        delete bonusItem.sent_quantity
                        delete bonusItem.issued_bonuses
                    }

                    return bonusItem
                })
            }
            if (isEdit) {
                data.event_id = item[0].event_id
                data.id = item[0].stage_id
            }
            value.push(data)
            return value
        }, [])

        const activitySetting = Object.keys(this.state.activitySetting).reduce((value, key) => {
            value.push({
                lang: key,
                entrance: this.state.redPacketImageData[key],
                desc: this.state.activitySetting[key]
            })
            return value
        }, [])

        const time = {
            start_at: utils.momentToUTCString(this.redPacketStartDate.state.endDate),
            end_at: utils.momentToUTCString(this.redPacketEndDate.state.endDate),
            cumulative_start_at: utils.momentToUTCString(this.accumulationStartDate.state.endDate),
            cumulative_end_at: utils.momentToUTCString(this.accumulationEndDate.state.endDate),
            redemption_end_at: utils.momentToUTCString(this.redemptionDeadlineDate.state.endDate),
        }

        const formData = new FormData()  // 無論編輯或新增都需要append的參數
        formData.append('name', this.state.name)
        formData.append('currency', this.redPacketpfSelect.state.currency)
        formData.append('budget', this.state.redPacketThreshold)
        formData.append('stage', JSON.stringify(stage))
        formData.append('is_active', this.state.redPacketStatus)
        formData.append('template', this.state.template)

        for (const key in this.redPacketpfSelect.state.pfSubPfIDList) {
            formData.append(`joined_sub_pf_list[]`, this.redPacketpfSelect.state.pfSubPfIDList[key])
        }
        for (const key in this.redPacketGameSelect.state.gameList) {
            formData.append(`joined_game_code_list[]`, this.redPacketGameSelect.state.gameList[key])
        }
        for (const key in time) {
            formData.append(key, time[key]);
        }

        if (isEdit) {                   // 需要區分編輯跟新增的參數
            formData.append('event_id', this.state.eventID)
            formData.append('is_expired', this.state.redPacketIsExpired)
            formData.append('redeemable', this.state.eventRedemptionStatus)
            formData.append('demo_stage', this.state.demoStage)
            for (const key in activitySetting) {
                formData.append(`content[${key}][lang]`, activitySetting[key]['lang'])
                const desc = activitySetting[key]['desc'] !== '<p><br></p>' ? activitySetting[key]['desc'] : ''
                formData.append(`content[${key}][desc]`, desc)
                if (activitySetting[key]['entrance'] instanceof File) {
                    formData.append(`content[${key}][entrance]`, activitySetting[key]['entrance'])
                }
            }
        } else {
            for (const key in activitySetting) {
                const desc = activitySetting[key]['desc'] !== '<p><br></p>' ? activitySetting[key]['desc'] : ''
                formData.append(`content[${key}][lang]`, activitySetting[key]['lang'])
                formData.append(`content[${key}][desc]`, desc)
                formData.append(`content[${key}][entrance]`, activitySetting[key]['entrance'])
            }
        }

        return formData
    }

    confirm = () => {
        this.setState({
            valid: true
        })
        const valid = []
        const errMsg = []
        /** 驗證活動名稱 */
        valid.push(this.handleNameValid())
        /** 平台驗證 */
        const pfSelect = this.state.type === MISC.EVENT_RED_PACKET ? this.redPacketpfSelect : this.pfSelect
        const gameSelect = this.state.type === MISC.EVENT_RED_PACKET ? this.redPacketGameSelect : this.gameSelect
        const datetimeSelect = this.state.type === MISC.EVENT_RED_PACKET ? this.redPacketStartDate?.state?.endDate : this.datetimeSelect?.state?.startDate
        if (pfSelect?.state.pfSubPfIDList.length <= 0) {
            valid.push(false)
            errMsg.push(this.t('choosePlatform'))
        }
        // /** 指定遊戲驗證 */
        if (gameSelect?.state.gameList.length <= 0) {
            valid.push(false)
            errMsg.push(this.t('chooseGames'))
        }
        /** 時間驗證 */
        if (this.datetimeSelect.isDateInvalid()) {
            valid.push(false)
            errMsg.push(this.t('ValidationMsg.startTimeCannotAfterEndTime'))
        }
        if (this.state.dialogType === 'add' && utils.getCurrentUTCMoment().unix() > utils.datetimeToUnix(datetimeSelect)) {
            valid.push(false)
            errMsg.push(this.t('DatePicker.startDateBeforeCurrentMessage'))
        }

        const misuValid = {
            [MISC.EVENT_RED_PACKET]: () => {
                if (!this.state.valid) {
                    this.setState({
                        valid: true
                    })
                }
                let isAllFields = true
                let is_demo = false
                // 驗證概率總和是否為100
                this.state.redPacketList.forEach((item) => {
                    item.forEach((listItem, index) => {
                        if (listItem.is_demo) {
                            /** 有開啟遊戲試玩 */
                            is_demo = true
                        }
                        if (index === 0) {
                            if (
                                String(listItem?.consume_points).length === 0 ||
                                String(listItem?.fake_max_bonus).length === 0 || 
                                String(listItem?.fake_min_bonus).length === 0 || 
                                String(listItem?.max_bonus).length === 0 || 
                                String(listItem?.min_bonus).length === 0 || 
                                String(listItem?.total_quantity).length === 0 || 
                                String(listItem?.winning_probability).length === 0
                            ) {
                                valid.push(false)
                                isAllFields = false
                            }
                        } else {
                            if (
                                String(listItem?.max_bonus).length === 0 || 
                                String(listItem?.min_bonus).length === 0 || 
                                String(listItem?.total_quantity).length === 0 || 
                                String(listItem?.winning_probability).length === 0
                            ) {
                                valid.push(false)
                                isAllFields = false
                            }
                        }
                    })
                    const percent = item.reduce((value, percentItem) => {
                        value += Number(percentItem.winning_probability)
                        return value
                    }, 0)
                    if (percent !== 100) {
                        errMsg.push(this.t(`percentError`, {
                            index: `${item[0].listIndex + 1}`
                        }))
                        valid.push(false)
                    }
                })
                if (!isAllFields) {
                    // 驗證 stage 是否每個欄位都有填
                    errMsg.push(this.t('isAllFields'))
                }

                // // 驗證時間格式
                const dateValidKey = [
                    'accumulationStartBeforeRedPacketStart',
                    'accumulationEndBeforeAccumulationStart',
                    'redemptionDeadlineBeforeAccumulationEnd',
                    'accumulationEndAfterRedPacketEnd'
                ]
                dateValidKey.forEach((key) => {
                    if (!this.handleDateValid(key)) {
                        errMsg.push(this.t(key))
                        valid.push(false)
                    }
                })

                Object.keys(this.state.activitySetting).forEach((key) => {
                    if (key === 'CHS' || key === 'ENU') {
                        if (!this.state.activitySetting[key]) {
                            errMsg.push(utils.t('descriptionRequired', 'EventDialog', { language: ` (${utils.t('Language.' + key).charAt(0)}) ` }));
                            valid.push(false)
                        }
                    }
                })
                /** 試玩門檻須擇一必選 */
                if (!is_demo) {
                    errMsg.push(utils.t('isDemoRequired', 'EventDialog'));
                    valid.push(false)
                }
            },
            [MISC.EVENT_DRAGON_TIGER_BOARD]: () => {
                if (this.state.dragonThreshold <= 0 || this.state.tigerThreshold <= 0) {
                    valid.push(false)
                }
                if (this.state.dragonTableData.length <= 0 || this.state.tigerTableData.length <= 0) {
                    errMsg.push(this.t('Event.validationMsg.emptyDtTable'))
                    valid.push(false)
                }
                if (this.state.dragonTableData.length > 1000 || this.state.tigerTableData.length > 1000) {
                    errMsg.push(this.t('Event.validationMsg.emptyDtTableExceed'))
                    valid.push(false)
                }
            },
            [MISC.EVENT_GIVE_FREE_GAME]: () => {
                valid.push(this.gfGame.handleValid())
            }
        }
        misuValid[this.state.type]()

        /** 錯誤訊息 */
        if (errMsg.length > 0) {
            errMsg.forEach(errorMsg => {
                utils.addToast(errorMsg, 'error')
            })
        }
        /** 資料驗證 */
        if (valid.find(value => !value) === false) { return }

        this.disableConfirmBtn()

        const promiseList = []

        if (this.state.dialogType === 'add') {
            promiseList.push(
                new Promise((resolve) => {
                    switch (this.state.type) {
                        case MISC.EVENT_RED_PACKET:
                            this.createdEventRedPacket(resolve)
                            break
                        case MISC.EVENT_DRAGON_TIGER_BOARD:
                            this.createdEventDragonTigerBoard(resolve)
                            break
                        case MISC.EVENT_GIVE_FREE_GAME:
                            this.createdEventGiveFreeGame(resolve)
                            break
                        default:
                    }
                })
            )
        } else if (this.state.dialogType === 'edit') {
            if (this.state.type === MISC.EVENT_RED_PACKET) {
                promiseList.push(
                    new Promise((resolve) => {
                        utils.apiRequest(
                            'put',
                            API.RED_PACKET,
                            this.getRedPacketFormData(),
                            (_data) => {
                                resolve()
                            },
                            (_err) => {
                                this.enableConfirmBtn()
                            }
                        )
                    })
                )
            } else if (this.state.type === MISC.EVENT_DRAGON_TIGER_BOARD) {
                promiseList.push(
                    new Promise((resolve) =>
                        utils.apiRequest(
                            'put',
                            API.DRAGON_TIGER_BOARD,
                            {
                                event_id: this.state.eventInfo['event_id'],
                                event_name: this.state.name,
                                joined_sub_pf_list: this.pfSelect.state.pfSubPfIDList,
                                joined_game_code_list: this.gameSelect.state.gameList,
                                end_at: utils.momentToUTCString(this.datetimeSelect.state.endDate),
                                dragon_awards: this.state.dragonTableData.map((elem) => elem.money),
                                dragon_threshold: this.state.dragonThreshold,
                                tiger_awards: this.state.tigerTableData.map((elem) => elem.money),
                                tiger_threshold: this.state.tigerThreshold,
                                is_enable: this.state.eventInfo['is_enable'],
                            },
                            (_data) => {
                                resolve()
                            },
                            (_err) => {
                                this.enableConfirmBtn()
                            }
                        )
                    )
                )
            } else if (this.state.type === MISC.EVENT_GIVE_FREE_GAME) {
                const { accountLimitCount, allPlatformLimitCount, resetLimitCycle } = this.gfGame.state
                const limit_prize_pf_account_count = Number(accountLimitCount) || -1
                const limit_prize_pf_count = Number(allPlatformLimitCount) || -1
                const params = {
                    event_id: this.state.eventInfo['event_id'],
                    name: this.state.name, //活動名稱
                    end_at: utils.momentToUTCString(this.datetimeSelect.state.endDate), // 結束時間(UTC+0)
                    joined_sub_pf_list: this.pfSelect.state.pfSubPfIDList, // 參與活動平台
                    joined_game_code_list: this.gameSelect.state.gameList, // 可累積打碼量的遊戲
                    play_game_code_list: this.freeGameSelect.state.gameList, // 可使用免費次數遊戲
                    limit_prize_pf_account_count, // 同帳號限制送出的次數
                    limit_prize_pf_count, // 全平台限制送出的次數
                    limit_reset_cycle: Number(resetLimitCycle), // 限制次數重置週期
                    is_enable: this.state.eventInfo['is_enable']
                }
                promiseList.push(
                    new Promise((resolve) =>
                        utils.apiRequest(
                            'put',
                            API.GIVE_FREE_GAME,
                            params,
                            (_data) => {
                                resolve()
                            },
                            (_err) => {
                                this.enableConfirmBtn()
                            }
                        )
                    )
                )
            }
        }

        Promise.all(promiseList).then(() => {
            if (this.props.confirmCallback) {
                this.props.confirmCallback()
            }
            this.closeDialog(false)
        })
    }

    createdEventRedPacket(resolve) {
        utils.apiRequest(
            'post',
            API.RED_PACKET,
            this.getRedPacketFormData(),
            (_data) => {
                resolve()
            },
            (_err) => {
                this.enableConfirmBtn()
            }
        )
    }
    createdEventDragonTigerBoard(resolve) {
        utils.apiRequest(
            'post',
            API.DRAGON_TIGER_BOARD,
            {
                event_name: this.state.name, //   string
                currency: this.pfSelect.state.currency, //   string
                joined_sub_pf_list: this.pfSelect.state.pfSubPfIDList, // []string
                joined_game_code_list: this.gameSelect.state.gameList, // []string
                dragon_awards: this.state.dragonTableData.map((elem) => elem.money), // []float64
                dragon_threshold: this.state.dragonThreshold, //   float64
                tiger_awards: this.state.tigerTableData.map((elem) => elem.money), // []float64
                tiger_threshold: this.state.tigerThreshold, //   float64
                start_at: utils.momentToUTCString(this.datetimeSelect.state.startDate), //   string
                end_at: utils.momentToUTCString(this.datetimeSelect.state.endDate), //   string
            },
            (_data) => {
                resolve()
            },
            (_err) => {
                this.enableConfirmBtn()
            }
        )
    }
    createdEventGiveFreeGame(resolve) {
        const { activityConditions, accumulationOrders, accumulationBets, accumulationReach, accountLimitCount, allPlatformLimitCount, resetLimitCycle, bonunsTotal, bonunsMin, resetbonunsCycle } = this.gfGame.state
        const accumulateBet = activityConditions === 'orders' ? accumulationOrders : 0
        const accumulateThreshold = activityConditions === 'bets' ? accumulationBets : 0
        const limit_prize_pf_account_count = Number(accountLimitCount) || -1
        const limit_prize_pf_count = Number(allPlatformLimitCount) || -1
        const params = {
            name: this.state.name, //活動名稱
            start_at: utils.momentToUTCString(this.datetimeSelect.state.startDate), //開始時間(UTC+0)
            end_at: utils.momentToUTCString(this.datetimeSelect.state.endDate), // 結束時間(UTC+0)
            currency: this.pfSelect.state.currency, // 幣別
            joined_sub_pf_list: this.pfSelect.state.pfSubPfIDList, // 參與活動平台
            joined_game_code_list: this.gameSelect.state.gameList, // 可累積打碼量的遊戲
            play_game_code_list: this.freeGameSelect.state.gameList, // 可使用免費次數遊戲
            accumulate_bet: Number(accumulateBet), // 累積注單數
            accumulate_threshold: Number(accumulateThreshold), // 累積打碼量
            every_prize_count: Number(accumulationReach), // 每次達成時送出次數
            limit_prize_pf_account_count, // 同帳號限制送出的次數
            limit_prize_pf_count, // 全平台限制送出的次數
            limit_reset_cycle: Number(resetLimitCycle), // 限制次數重置週期
            prize_pool_money: Number(bonunsTotal), // 獎金池金額
            ban_threshold_money: Number(bonunsMin), // 活動獎金低於此欄位時，只出小獎
            prize_reset_cycle: Number(resetbonunsCycle) // 獎金池重置週期
        }
        utils.apiRequest(
            'post',
            API.GIVE_FREE_GAME,
            params,
            (_data) => {
                resolve()
            },
            (_err) => {
                this.enableConfirmBtn()
            }
        )
    }

    handleSetDefaultGameListValue(bool) {
        if (bool) {
            /** 設定預設值 */
            this.gameSelect.setState({
                gameList: defaultSelectForGame
            })
            this.freeGameSelect.setState({
                gameList: defaultSelectForGame
            })
        } else {
            /** 清空預設值 */
            this.gameSelect.setState({
                gameList: []
            })
            this.freeGameSelect.setState({
                gameList: []
            })
        }
    }

    antIcon() {
        return <Icon type="loading" style={{ fontSize: 18 }} spin />
    }

    /** 龍虎榜獎項新增/編輯視窗 */
    handleOpenDragonTigerDialog(dialogType, type) {
        this.setState({
            dragonTigerEditDialog: true,
            dragonTigerEditDialogType: dialogType,
            dragonTigerEditType: type
        })
    }
    /** 龍虎榜獎項新增/編輯 */
    handleDragonTigerAwards(amount, count) {
        const dataKey = this.state.dragonTigerEditType === 'dragon' ? 'dragonTableData' : 'tigerTableData'
        /** 排名總數不得大於1000 */
        if (new Decimal(this.state[dataKey].length).add(count) > 1000) {
            utils.addToast('排名總數量不得大於1000', 'error')
            return
        }
        const dialogInit = {
            dragonTigerEditDialog: false,
            dragonTigerEditDialogType: '',
            dragonTigerEditType: '',
            dragonTigerEditData: []
        }
        let data = []
        data = [...this.state[dataKey]]
        if (this.state.dragonTigerEditDialogType === 'edit') {
            this.state.dragonTigerEditData.forEach(item => {
                const dataIndex = data.findIndex(origin => origin.rank === item.rank)
                data[dataIndex].money = Number(amount)
                data[dataIndex].isNew = true
            })
        } else {
            const newData = []
            for (let i = 0; i < Number(count); i++) {
                newData.push({
                    money: Number(amount),
                    type: this.state.dragonTigerEditType,
                    isNew: true
                })
            }
            data = [...data, ...newData]
        }

        this.setState({
            ...dialogInit,
            [dataKey]: rankDragonTigerTableData(data),

        })
    }
    /** 龍虎榜獎項刪除 */
    handleDragonTigerDelete(data, type) {
        this.confirmDialog.OpenDialog({
            type: 'warn',
            msg: this.t('confirmDeleteMsg'),
            confirm: (_params) => {
                const dataKey = type === 'dragon' ? 'dragonTableData' : 'tigerTableData'
                const delData = data.map(item => item.rank)
                const newData = this.state[dataKey].filter(item => {
                    return !delData.includes(item.rank)
                })
                this.setState({
                    [dataKey]: rankDragonTigerTableData(newData),
                }, () => {
                    this.confirmDialog.closeDialog()
                })
            },
        })
    }

    handleTableStyle() {
        setTimeout(() => {
            const headers = document.querySelectorAll('.ant-modal-header')
            const closeIcon = document.querySelectorAll('.ant-modal-close-x')
            const title = document.querySelectorAll('.ant-modal-title')
            headers.forEach((item) => {
                item.style.backgroundColor = '#69131C'
            })
            closeIcon.forEach((item) => {
                item.style.color = 'white'
            })
            title.forEach((item) => {
                item.style.color = 'white'
            })
        })
    }
    
    handleTableRender() {
        setTimeout(() => {
            const elementsToRemove = document.querySelectorAll('.removeTd');
            elementsToRemove.forEach(element => {
                const parent = element.parentNode;
                parent.removeChild(element);
            });
        })
    }

    redPacketColumns = [
        {
            title: utils.t('activityThreshold', 'EventDialog'),
            dataIndex: 'activityThreshold',
            width: 150,
            onCell: () => ({ style: { backgroundColor: 'white', height: '150px' } }),
            render: (_text, record, index) => {
                const isDisabled = this.state.redPacketIsStart && !this.state.isCopy
                if (index === 0) {
                    return {
                        children: (
                            <Grid container>
                                <Grid xs={12} item>
                                    <Form>
                                        <Form.Item
                                            style={{marginBottom: '0'}}
                                            validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].consume_points).length === 0 ? 'error' : ''}
                                        >
                                            <Input
                                                className={this.props.classes.redPacketInput}
                                                type='text'
                                                value={this.state.redPacketList[record.listIndex][index].consume_points}
                                                onChange={(event) => {
                                                    const value = event.target.value
                                                    const redPacketList = this.state.redPacketList
                                                    redPacketList[record.listIndex][index] = {
                                                        ...redPacketList[record.listIndex][index],
                                                        listIndex: record.listIndex,
                                                        consume_points: value
                                                            .replace(/[^0-9.]/g, '')
                                                            .replace(/(\..*)\./g, '$1')
                                                            .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                                    }
                                                    this.setState({ redPacketList })
                                                }}
                                                disabled={isDisabled}
                                            />
                                        </Form.Item>
                                    </Form>
                                </Grid>
                                <Grid xs={12} item>
                                    <Checkbox
                                        disabled={
                                            this.state.redPacketList.some(innerArray => innerArray[0].is_demo) &&
                                            !this.state.redPacketList[record.listIndex][0].is_demo
                                        }
                                        checked={this.state.redPacketList[record.listIndex][index].is_demo}
                                        onChange={(event) => {
                                            const value = event.target.checked
                                            const redPacketList = this.state.redPacketList
                                            redPacketList[record.listIndex].forEach((child, index) => {
                                                redPacketList[record.listIndex][index] = {
                                                    ...child,
                                                    listIndex: record.listIndex,
                                                    is_demo: value
                                                }
                                            })
                                            this.setState({ redPacketList })
                                        }}
                                        color="primary"
                                        size='small'
                                    />
                                    {this.t('startTrial')}
                                </Grid>
                                {this.state.redPacketList.length > 1 && <Grid
                                    item
                                    xs={12}
                                    className={this.props.classes.redPacketRemove}
                                    onClick={() => {
                                        if (isDisabled) return
                                        if (this.state.redPacketList.length > 1) {
                                            this.confirmDialog.OpenDialog({
                                                type: 'warn',
                                                msg: this.t('confirmDeletionThreshold'),
                                                confirm: (_params) => {
                                                    const redPacketList = JSON.parse(JSON.stringify(this.state.redPacketList))
                                                    const filterList = redPacketList.filter((item) => item[0].listIndex !== record.listIndex)
                                                    this.setState({
                                                        redPacketList: filterList.map((item, index) => item.map((data) => {
                                                            data.listIndex = index
                                                            return data
                                                        }))
                                                    }, () => {
                                                        this.handleTableRender()
                                                        this.confirmDialog.closeDialog()
                                                    })
                                                },
                                            })
                                        }
                                    }}
                                >
                                    <Icon
                                        className={this.props.classes.redPacketActionBtn} type="delete"
                                        style={{
                                            color: isDisabled ? '#BDBDBD' : '#69131C',
                                        }}
                                    />
                                    <span>{this.t('delete')}</span>
                                </Grid>}
                            </Grid>
                        ),
                        props: {
                            rowSpan: this.state.redPacketList[record.listIndex]?.length
                        },
                    };
                }

                return { props: { className: 'removeTd' } }
            },
        },
        {
            title: utils.t('number', 'EventDialog'),
            dataIndex: 'number',
            width: 100,
            onCell: () => ({ style: { backgroundColor: 'white' } }),
            render: (_text, _record, index) => {
                return index + 1
            }
        },
        {
            title: utils.t('fakeBonusLower', 'EventDialog'),
            dataIndex: 'fakeBonusLower',
            width: 115,
            onCell: () => ({ style: { backgroundColor: 'white' } }),
            render: (_text, record, index) => {
                if (index === 0) {
                    return {
                        children: (
                            <Grid container>
                                <Grid xs={12} item>
                                    <Form>
                                        <Form.Item
                                            style={{marginBottom: '0'}}
                                            validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].fake_min_bonus).length === 0 ? 'error' : ''}
                                        >
                                            <Input
                                                value={this.state.redPacketList[record.listIndex][index].fake_min_bonus}
                                                onChange={(event) => {
                                                    const value = event.target.value
                                                    const redPacketList = this.state.redPacketList
                                                    redPacketList[record.listIndex][index] = {
                                                        ...redPacketList[record.listIndex][index],
                                                        listIndex: record.listIndex,
                                                        fake_min_bonus: value
                                                            .replace(/[^0-9.]/g, '')
                                                            .replace(/(\..*)\./g, '$1')
                                                            .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                                    }
                                                    this.setState({ redPacketList })
                                                }}
                                                className={this.props.classes.redPacketInput}
                                                type='text'
                                                disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                            />
                                        </Form.Item>
                                    </Form>
                                   
                                </Grid>
                            </Grid>
                        ),
                        props: {
                            rowSpan: this.state.redPacketList[record.listIndex]?.length,
                        },
                    };
                }

                return { props: { className: 'removeTd' } }
            },
        },
        {
            title: utils.t('fakeBonusUp', 'EventDialog'),
            dataIndex: 'fakeBonusUp',
            width: 115,
            key: 'fakeBonusUp',
            onCell: () => ({ style: { backgroundColor: 'white', width: '130px' } }),
            render: (_text, record, index) => {
                if (index === 0) {
                    return {
                        children: (
                            <Grid container>
                                <Grid xs={12} item>
                                    <Form>
                                        <Form.Item
                                            style={{marginBottom: '0'}}
                                            validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].fake_max_bonus).length === 0 ? 'error' : ''}
                                        >
                                        <Input
                                            value={this.state.redPacketList[record.listIndex][index].fake_max_bonus}
                                            onChange={(event) => {
                                                const value = event.target.value
                                                const redPacketList = this.state.redPacketList
                                                redPacketList[record.listIndex][index] = {
                                                    ...redPacketList[record.listIndex][index],
                                                    listIndex: record.listIndex,
                                                    fake_max_bonus: value
                                                        .replace(/[^0-9.]/g, '')
                                                        .replace(/(\..*)\./g, '$1')
                                                        .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                                }
                                                this.setState({ redPacketList })
                                            }}
                                            className={this.props.classes.redPacketInput}
                                            type='text'
                                            disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                        />
                                        </Form.Item>
                                    </Form>
                                </Grid>
                            </Grid>
                        ),
                        props: {
                            rowSpan: this.state.redPacketList[record.listIndex]?.length,
                        },
                    };
                }

                return { props: { className: 'removeTd' } }
            },
        },
        {
            title: utils.t('bonusLower', 'EventDialog'),
            dataIndex: 'bonusLower',
            width: 100,
            key: 'bonusLower',
            onCell: () => ({ style: { backgroundColor: 'white', with: '50px' } }),
            render: (_text, record, index) => {
                return (
                    <Grid container>
                        <Grid xs={12} item>
                            <Form>
                                <Form.Item
                                    style={{marginBottom: '0'}}
                                    validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].min_bonus).length === 0 ? 'error' : ''}
                                >
                                    <Input
                                        value={this.state.redPacketList[record.listIndex][index].min_bonus}
                                        onChange={(event) => {
                                            const value = event.target.value
                                            const redPacketList = this.state.redPacketList
                                            redPacketList[record.listIndex][index] = {
                                                ...redPacketList[record.listIndex][index],
                                                listIndex: record.listIndex,
                                                min_bonus: value
                                                    .replace(/[^0-9.]/g, '')
                                                    .replace(/(\..*)\./g, '$1')
                                                    .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                            }
                                            this.setState({ redPacketList })
                                        }}
                                        className={this.props.classes.redPacketInput}
                                        type='text'
                                        disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                    />
                                </Form.Item>
                            </Form>

                        </Grid>
                    </Grid>
                )
            }
        },
        {
            title: utils.t('bonusUp', 'EventDialog'),
            dataIndex: 'bonusUp',
            width: 100,
            key: 'bonusUp',
            onCell: () => ({ style: { backgroundColor: 'white', with: '50px' } }),
            render: (_text, record, index) => {
                return (
                    <Grid container>
                        <Grid xs={12} item>
                            <Form>
                                <Form.Item
                                    style={{marginBottom: '0'}}        
                                    validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].max_bonus).length === 0 ? 'error' : ''}
                                >
                                    <Input
                                        value={this.state.redPacketList[record.listIndex][index].max_bonus}
                                        onChange={(event) => {
                                            const value = event.target.value
                                            const redPacketList = this.state.redPacketList
                                            redPacketList[record.listIndex][index] = {
                                                ...redPacketList[record.listIndex][index],
                                                listIndex: record.listIndex,
                                                max_bonus: value
                                                    .replace(/[^0-9.]/g, '')
                                                    .replace(/(\..*)\./g, '$1')
                                                    .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                            }
                                            this.setState({ redPacketList })
                                        }}
                                        className={this.props.classes.redPacketInput}
                                        type='text'
                                        disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                    />
                                </Form.Item>
                            </Form>
                        </Grid>
                    </Grid>
                )
            }
        },
        {
            title: utils.t('percent', 'EventDialog'),
            dataIndex: 'percent',
            width: 100,
            key: 'percent',
            onCell: () => ({ style: { backgroundColor: 'white' } }),
            render: (_text, record, index) => {
                return (
                    <Grid container>
                        <Grid xs={12} item>
                            <Form>
                                <Form.Item
                                    style={{marginBottom: '0'}}
                                    validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].winning_probability).length === 0 ? 'error' : ''}
                                >
                                    <Input
                                        value={this.state.redPacketList[record.listIndex][index].winning_probability}
                                        onChange={(event) => {
                                            const value = event.target.value.replace(/[^0-9.]/g, '')
                                            const redPacketList = this.state.redPacketList
                                            redPacketList[record.listIndex][index] = {
                                                ...redPacketList[record.listIndex][index],
                                                listIndex: record.listIndex,
                                                winning_probability: Number(value) > 100 ? 100 : Number(value)
                                            }
                                            this.setState({ redPacketList })
                                        }}
                                        className={this.props.classes.redPacketInput}
                                        type='text'
                                    />
                                </Form.Item>
                            </Form>
                           
                        </Grid>
                    </Grid>
                )
            }
        },
        {
            title: utils.t('quantity', 'EventDialog'),
            dataIndex: 'quantity',
            key: 'quantity',
            width: 220,
            onCell: () => ({ style: { backgroundColor: 'white' } }),
            render: (_text, record, index) => {
                return (
                    <Grid container>
                        <Grid xs={6} item>
                            <Form>
                                <Form.Item style={{marginBottom: '0'}}>
                                    <Input
                                        disabled={true}
                                        className={this.props.classes.redPacketInput}
                                        type='text'
                                        value={(record.sent_quantity >= 0 && !this.state.isCopy) ? `${record.sent_quantity}` : utils.t('isUnsent', 'EventPrizeDetailRedPacketDialog')}
                                        style={{
                                            color: (Number(record.sent_quantity) > Number(this.state.redPacketList[record.listIndex][index].total_quantity) * 0.70) && !this.state.isCopy ? '#FFA3A3' : ''
                                        }}
                                    />
                                </Form.Item>
                            </Form>
                        </Grid>
                        <Grid xs={6} item style={{ paddingLeft: '10px' }}>
                            <Form>
                                <Form.Item
                                    style={{marginBottom: '0'}}
                                    validateStatus={this.state.valid && String(this.state.redPacketList[record.listIndex][index].total_quantity).length === 0 ? 'error' : ''}
                                >
                                    <Input
                                        value={this.state.redPacketList[record.listIndex][index].total_quantity}
                                        onChange={(event) => {
                                            const value = event.target.value
                                            const redPacketList = this.state.redPacketList
                                            redPacketList[record.listIndex][index] = {
                                                ...redPacketList[record.listIndex][index],
                                                listIndex: record.listIndex,
                                                total_quantity: value
                                                    .replace(/[^0-9.]/g, '')
                                                    .replace(/(\..*)\./g, '$1')
                                                    .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                            }
                                            this.setState({ redPacketList })
                                        }}
                                        className={this.props.classes.redPacketInput}
                                        type='text'
                                    />
                                </Form.Item>
                            </Form>
                        </Grid>
                    </Grid>
                )
            }
        },
        {
            title: utils.t('issueBonus', 'EventDialog'),
            dataIndex: 'issueBonus',
            width: 150,
            key: 'issueBonus',
            onCell: () => ({ style: { backgroundColor: 'white' } }),
            render: (_text, record, _index) => {
                return (
                    <Grid container>
                        <Grid xs={12} item>
                            <Form>
                                <Form.Item style={{marginBottom: '0'}}>
                                    <Input
                                        placeholder={(record.issued_bonuses >= 0 && !this.state.isCopy) ? `${record.issued_bonuses}` : utils.t('isUnsent', 'EventPrizeDetailRedPacketDialog')}
                                        disabled
                                        className={this.props.classes.redPacketInput}
                                        type='text'
                                    />
                                </Form.Item>
                            </Form>
                        </Grid>
                    </Grid>
                )
            }
        },
        {
            title: utils.t('action', 'EventDialog'),
            dataIndex: 'action',
            width: 100,
            key: 'action',
            align: 'center',
            onCell: () => ({ style: { backgroundColor: 'white' } }),
            render: (_text, record, index) => {
                const cloneRedPacketList = JSON.parse(JSON.stringify(this.state.redPacketList))
                const isDisabled = this.state.redPacketIsStart && !this.state.isCopy
                return (
                    <div className={this.props.classes.redPacketActionCol} >
                        {index + 1 === this.state.redPacketList[record.listIndex]?.length && (
                            <Icon
                            
                                onClick={() => {
                                    if (cloneRedPacketList[record.listIndex].length >= 15) return
                                    if (isDisabled) return
                                    cloneRedPacketList[record.listIndex].push({
                                        listIndex: record.listIndex,
                                        tableKey: `${cloneRedPacketList[record.listIndex][0].stage_id}.${cloneRedPacketList[record.listIndex].length}` // 無論第幾組的stage_id都等於外層id所以拿第一個
                                    })
                                    this.setState({
                                        redPacketList: cloneRedPacketList
                                    }, () => {
                                        this.handleTableRender()
                                    })
                                }}
                                className={this.props.classes.redPacketActionBtn}
                                type="plus-square"
                                style={{
                                    color: isDisabled ? '#BDBDBD' : '#69131C',
                                }}
                            />
                        )}
                        {cloneRedPacketList[record.listIndex]?.length > 1 && <Icon
                            onClick={() => {
                                if (isDisabled) return
                                if (cloneRedPacketList[record.listIndex]?.length > 1) {
                                    cloneRedPacketList[record.listIndex].splice(index, 1)

                                    if (index === 0) { // 若從第一個刪除則更新 tableKey 重新渲染
                                        cloneRedPacketList[record.listIndex][index].tableKey 
                                            = `${cloneRedPacketList[record.listIndex][index]?.id - 1}.${cloneRedPacketList[record.listIndex][index]?.stage_id}`;
                                    }

                                    this.setState({
                                        redPacketList: cloneRedPacketList
                                    }, () => {
                                        this.handleTableRender()
                                    })
                                }
                            }}
                            className={this.props.classes.redPacketActionBtn}
                            style={{
                                color: isDisabled ? '#BDBDBD' : '#69131C',
                            }}
                            type="delete"
                        />}
                    </div>
                )
            }
        },
    ];

    render() {
        const isRedPacket = this.state.type === MISC.EVENT_RED_PACKET
        const isTigerBoadrd = this.state.type === MISC.EVENT_DRAGON_TIGER_BOARD
        const isFreeGame = this.state.type === MISC.EVENT_GIVE_FREE_GAME
        return (
            <Modal
                zIndex={1200}
                title={this.t(this.state.dialogType)}
                visible={this.state.dialogOpen}
                onOk={this.handleOk}
                onCancel={() => {
                    this.closeDialog()
                }}
                width={'90%'}
                footer={[
                    <Button
                        key="modal_confirm"
                        variant="contained"
                        onClick={() => this.confirm()}
                        color="primary"
                        disabled={this.state.confirmBtnDisable}
                    >
                        {this.state.loading && <Spin indicator={this.antIcon()} className={this.props.classes.loadingIcon} />}
                        {this.t(this.state.dialogType === 'add' ? 'confirm' : 'save')}
                    </Button>,
                    <Button key="modal_cancel" variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                ]}
            >
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Grid item xs={12} style={{ display: 'flex' }}>
                            <Select
                                className={this.props.classes.select}
                                label={this.t('type')}
                                value={this.state.type}
                                onChange={(event) => {
                                    this.setState({
                                        type: event.target.value,
                                        valid: false
                                    })
                                    /** 新增狀態 => 遊戲選單設定預設值 */
                                    this.state.dialogType === 'add' && this.handleSetDefaultGameListValue(false)
                                }}
                                menuItemList={[
                                    {
                                        value: MISC.EVENT_RED_PACKET,
                                        display: this.t('Event.' + MISC.EVENT_RED_PACKET),
                                    },
                                    {
                                        value: MISC.EVENT_DRAGON_TIGER_BOARD,
                                        display: this.t('Event.' + MISC.EVENT_DRAGON_TIGER_BOARD),
                                    },
                                    {
                                        value: MISC.EVENT_GIVE_FREE_GAME,
                                        display: this.t('Event.' + MISC.EVENT_GIVE_FREE_GAME),
                                    },
                                ]}
                                disabled={this.state.dialogType === 'edit'}
                            />
                            {isRedPacket && <Select
                                className={this.props.classes.select}
                                label={this.t('template')}
                                value={this.state.template}
                                onChange={(event) => {
                                    this.setState({
                                        template: event.target.value
                                    })
                                }}
                                menuItemList={[
                                    {
                                        value: "LuckyWheel",
                                        display: "LuckyWheel",
                                    }
                                ]}
                                disabled={this.state.dialogType === 'edit'}
                            />}
                        </Grid>
                        {/* 抽紅包的左邊 */}
                        <Grid container hidden={!isRedPacket}>
                            <Grid item xs={12}>
                                <TextField
                                    className={this.props.classes.textField}
                                    label={this.t('name')}
                                    value={this.state.name}
                                    onChange={(event) =>
                                        this.setState({
                                            name: event.target.value,
                                        })
                                    }
                                    error={this.state.valid && !this.handleNameValid()}
                                    helperText={this.state.valid && !this.handleNameValid() ? this.t('eventNameValid') : ''}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                {/* // 平台 */}
                                <PfSubPfMultiSelect
                                    onRef={(ref) => (this.redPacketpfSelect = ref)}
                                    currencyOnChange={(currency) => {
                                        if (this.state.dialogType === 'add') {
                                            this.updateTableColumnTitle(currency)
                                        }
                                        this.setState({
                                            currency
                                        })
                                    }}
                                    options={{
                                        hideAllPlatform: true,
                                        disabledList: this.state.subPfSelectDisabledList
                                    }}>
                                </PfSubPfMultiSelect>
                            </Grid>
                            <Grid item xs={12}>
                                <DateBasicSelect
                                    onRef={(ref) => (this.redPacketStartDate = ref)}
                                    label={this.t('redPacketStartDate')}
                                    disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                />
                                <DateBasicSelect
                                    onRef={(ref) => (this.redPacketEndDate = ref)}
                                    label={this.t('redPacketEndDate')}
                                    disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <DateBasicSelect
                                    error={(this.state.valid && !this.handleDateValid('accumulationStartBeforeRedPacketStart'))}
                                    helperText={
                                        this.state.valid && !this.handleDateValid('accumulationStartBeforeRedPacketStart') ? this.t('accumulationStartBeforeRedPacketStart') : ''
                                    }
                                    onRef={(ref) => (this.accumulationStartDate = ref)}
                                    label={this.t('accumulationStartDate')}
                                    disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                />
                                <DateBasicSelect
                                    error={
                                        (this.state.valid && !this.handleDateValid('accumulationEndBeforeAccumulationStart')) ||
                                        (this.state.valid && !this.handleDateValid('accumulationEndAfterRedPacketEnd'))
                                    }
                                    helperText={
                                        (this.state.valid && !this.handleDateValid('accumulationEndBeforeAccumulationStart')) ? this.t('accumulationEndBeforeAccumulationStart') :
                                            (this.state.valid && !this.handleDateValid('accumulationEndAfterRedPacketEnd')) ? this.t('accumulationEndAfterRedPacketEnd') : ''
                                    }
                                    onRef={(ref) => (this.accumulationEndDate = ref)}
                                    label={this.t('accumulationEndDate')}
                                    disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <DateBasicSelect
                                    error={this.state.valid && !this.handleDateValid('redemptionDeadlineBeforeAccumulationEnd')}
                                    helperText={
                                        this.state.valid && !this.handleDateValid('redemptionDeadlineBeforeAccumulationEnd') ? this.t('redemptionDeadlineBeforeAccumulationEnd') : ''
                                    }
                                    onRef={(ref) => (this.redemptionDeadlineDate = ref)}
                                    label={this.t('redemptionDeadlineDate')}
                                    disabled={this.state.redPacketIsStart && !this.state.isCopy}
                                />
                            </Grid>
                            {this.state.dialogType !== 'add' && <Grid item container xs={12}>
                                <Select
                                    className={this.props.classes.select}
                                    label={this.t('eventRedemptionStatus')}
                                    value={this.state.eventRedemptionStatus}
                                    onChange={(event) => {
                                        this.setState({
                                            eventRedemptionStatus: event.target.value
                                        })
                                    }}
                                    menuItemList={[
                                        {
                                            value: 'true',
                                            display: this.t('active'),
                                        },
                                        {
                                            value: 'false',
                                            display: this.t('close'),
                                        }
                                    ]}
                                    disabled={this.state.dialogType === 'edit'}
                                />
                            </Grid>}
                            <Grid item xs={12}>
                                <GameMultiSelect
                                    subTitle={this.t('cumulativeTimesOfGames') || ''}
                                    gameOpenedList={this.state.redPacketDefaultSelectForGame || []}
                                    typeName={this.state.type}
                                    onRef={(ref) => (this.redPacketGameSelect = ref)}
                                    disabledList={this.state.gameSelectDisabledList}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Select
                                    className={this.props.classes.select}
                                    label={this.t('isActive')}
                                    value={this.state.redPacketStatus}
                                    onChange={(event) => {
                                        this.setState({
                                            redPacketStatus: event.target.value
                                        })
                                    }}
                                    menuItemList={[
                                        {
                                            value: 'true',
                                            display: this.t('active'),
                                        },
                                        {
                                            value: 'false',
                                            display: this.t('close'),
                                        }
                                    ]}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <Button
                                    style={{ marginLeft: '8px', marginTop: '10px' }}
                                    variant="contained"
                                    onClick={() => {
                                        const inputs = {
                                            title: utils.t('addActivityImage', 'EventDialog')
                                        }
                                        if (this.state.dialogType === 'edit') {
                                            inputs.imageData = { ...initialState.redPacketImageData, ...this.state.redPacketImageData }
                                            this.UploadActivityImgDialog.OpenDialog(inputs)
                                        } else {
                                            this.UploadActivityImgDialog.setState({
                                                imageData: initialState.redPacketImageData
                                            }, () => {
                                                this.UploadActivityImgDialog.OpenDialog(inputs)
                                            })
                                        }
                                    }}
                                    color="primary"
                                >
                                    {this.t('uploadActivityImg')}
                                </Button>
                            </Grid>
                        </Grid>
                        {/* 不是抽紅包的左邊 */}
                        <Grid container hidden={isRedPacket}>
                            <Grid item xs={12}>
                                <TextField
                                    className={this.props.classes.textField}
                                    label={this.t('name')}
                                    value={this.state.name}
                                    onChange={(event) =>
                                        this.setState({
                                            name: event.target.value,
                                        })
                                    }
                                    error={this.state.valid && !this.handleNameValid()}
                                    helperText={this.state.valid && !this.handleNameValid() ? this.t('eventNameValid') : ''}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.enableMaxGachaPacket}
                                            onChange={(event) => {
                                                this.setState({
                                                    enableMaxGachaPacket: event.target.checked,
                                                })
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label={this.t('Event.maxGachaPacket')}
                                />
                                <TextField
                                    className={this.props.classes.textField}
                                    label=""
                                    value={this.state.maxGachaPacket}
                                    disabled={!this.state.enableMaxGachaPacket}
                                    onChange={(event) =>
                                        this.setState({
                                            maxGachaPacket: event.target.value,
                                        })
                                    }
                                    error={this.state.valid && this.state.enableMaxGachaPacket && 0 >= this.state.maxGachaPacket}
                                    helperText={this.state.valid && this.state.enableMaxGachaPacket && 0 >= this.state.maxGachaPacket ? this.t('ValidationMsg.inputMustGreaterThan') + '0' : ''}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={this.state.enableMaxAwardThreshold}
                                            onChange={(event) => {
                                                this.setState({
                                                    enableMaxAwardThreshold: event.target.checked,
                                                })
                                            }}
                                            color="primary"
                                        />
                                    }
                                    label={this.t('Event.maxAwardThreshold')}
                                />
                                <TextField
                                    className={this.props.classes.textField}
                                    label=""
                                    value={this.state.maxAwardThreshold}
                                    disabled={!this.state.enableMaxAwardThreshold}
                                    onChange={(event) =>
                                        this.setState({
                                            maxAwardThreshold: event.target.value,
                                        })
                                    }
                                    error={this.state.valid && this.state.enableMaxAwardThreshold && 0 >= this.state.maxAwardThreshold}
                                    helperText={this.state.valid && this.state.enableMaxAwardThreshold && 0 >= this.state.maxAwardThreshold ? this.t('ValidationMsg.inputMustGreaterThan') + '0' : ''}
                                    InputProps={{
                                        endAdornment: <InputAdornment position="end">{this.t('gameCurrency')}</InputAdornment>,
                                    }}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <DatetimeSelect
                                    onRef={(ref) => (this.datetimeSelect = ref)}
                                    startDateMinDate={
                                        this.state.dialogType === 'add' && utils.datetimeStartOfWithoutOffset(utils.currentDatetime(), 'day')
                                    }
                                />
                            </Grid>
                            <Grid item xs={12}>
                                <PfSubPfMultiSelect
                                    onRef={(ref) => (this.pfSelect = ref)}
                                    currencyOnChange={(currency) => {
                                        if (this.state.dialogType === 'add') {
                                            this.updateTableColumnTitle(currency)
                                        }
                                    }}
                                    options={{
                                        hideAllPlatform: true,
                                        disabledList: this.state.subPfSelectDisabledList
                                    }}>
                                </PfSubPfMultiSelect>
                            </Grid>
                            <Grid item xs={12}>
                                <GameMultiSelect
                                    subTitle={this.state.type === MISC.EVENT_GIVE_FREE_GAME ? this.t('cumulativeTimesOfGames') : ''}
                                    gameOpenedList={this.state.type === MISC.EVENT_GIVE_FREE_GAME ? defaultSelectForGame : []}
                                    typeName={this.state.type}
                                    onRef={(ref) => (this.gameSelect = ref)}
                                    disabledList={this.state.gameSelectDisabledList}
                                />
                            </Grid>
                            <Grid item xs={12} hidden={!isFreeGame}>
                                <GameMultiSelect
                                    subTitle={this.t('gamesAvailableForFree')}
                                    hideTitle={true}
                                    typeName={this.state.type}
                                    gameOpenedList={defaultSelectForGame}
                                    onRef={(ref) => (this.freeGameSelect = ref)}
                                    disabledList={this.state.freeGameSelectDisabledList}
                                />
                            </Grid>
                        </Grid>
                    </Grid>
                    {/* 抽紅包的右邊 */}
                    {isRedPacket && (
                        <Grid item xs={8}>
                            <Grid item xs={12} className={this.props.classes.activityBtnList} >
                                <Button
                                    className={this.props.classes.activityBtn}
                                    variant="contained"
                                    onClick={() => {
                                        this.setState({
                                            redPacketSelectTitle: 'setting'
                                        })
                                        this.handleTableRender()
                                    }}
                                    color={this.state.redPacketSelectTitle === 'setting' ? 'primary' : 'secondary'}
                                >
                                    {this.t('activitySetting')}
                                </Button>
                                {
                                    Object.keys(this.state.activitySetting).map((key) => {
                                        return (
                                            <div key={key} >
                                                <Button
                                                    className={this.props.classes.activityBtn}
                                                    variant="contained"
                                                    onClick={() => {
                                                        this.setState({
                                                            redPacketSelectTitle: key,
                                                        }, () => {
                                                            this.editor.setState({
                                                                text: this.state.activitySetting[key]
                                                            })
                                                            this.handleTableRender()
                                                        })
                                                    }}
                                                    color={this.state.redPacketSelectTitle === key ? 'primary' : 'secondary'}
                                                >
                                                    {this.t('activityDescription')} ({utils.t('Language.' + key).charAt(0)})
                                                </Button>
                                            </div>
                                        )
                                    })
                                }
                            </Grid>
                            {
                                this.state.redPacketSelectTitle === 'setting' ?
                                    <>
                                        <Grid item xs={12} className={this.props.classes.timeBar}>
                                            <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                                <div style={{ display: 'flex' }}>
                                                    <div>
                                                        <div className={this.props.classes.localTime}>
                                                            <div>{this.t('localTime')}</div>
                                                            {<div>{utils.getCurrentTimeByCurrency(this.state.currency)}</div>}
                                                        </div>
                                                    </div>
                                                    <TextField
                                                        className={this.props.classes.textField}
                                                        label={this.t('activityBudget')}
                                                        value={this.state.redPacketThreshold}
                                                        type={'text'}
                                                        onChange={(event) => {
                                                            const value = event.target.value
                                                                .replace(/[^0-9.]/g, '')
                                                                .replace(/(\..*)\./g, '$1')
                                                                .replace(/^(\d+)\.(\d\d).*/, '$1.$2')
                                                            this.setState({
                                                                redPacketThreshold: value,
                                                            })
                                                        }}
                                                        error={this.state.valid && this.state.redPacketThreshold <= 0}
                                                        helperText={this.state.valid && this.state.redPacketThreshold <= 0 ? `${this.t('Event.validationMsg.thresholdCannotLessThan')} 0` : ''}
                                                    />
                                                </div>
                                                <div style={{ paddingRight: '17px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                                    <p
                                                        style={{
                                                            fontWeight: '700',
                                                            color: (this.state.redPacketIsStart && !this.state.isCopy) ? '#BDBDBD' : '#69131C',
                                                            paddingTop: '13px',
                                                            paddingRight: '15px'
                                                        }}
                                                    >
                                                        {this.t('action')}
                                                    </p>
                                                    <Icon
                                                        onClick={() => {
                                                            if (this.state.redPacketList.length >= 15) return 
                                                            if (this.state.redPacketIsStart && !this.state.isCopy) return
                                                            const redPacketList = JSON.parse(JSON.stringify(this.state.redPacketList))
                                                            redPacketList.push([{
                                                                listIndex: redPacketList.length,
                                                                tableKey: `${redPacketList.length}`
                                                            }])
                                                            this.setState({
                                                                redPacketList
                                                            }, () => {
                                                                this.handleTableRender()
                                                            })
                                                        }}
                                                        style={{
                                                            fontSize: '30px',
                                                            color: (this.state.redPacketIsStart && !this.state.isCopy) ? '#BDBDBD' : '#69131C'
                                                        }}
                                                        type="plus-square"
                                                    />
                                                </div>
                                            </div>
                                        </Grid>
                                        {
                                            this.state.redPacketList.map((item) => {
                                                return (
                                                    <div key={item[0].listIndex} style={{ paddingBottom: '15px' }}>
                                                        <Table
                                                            scroll={{ x: true }}
                                                            columns={this.redPacketColumns}
                                                            dataSource={item}
                                                            bordered
                                                            pagination={false}
                                                            rowKey="tableKey"
                                                        />
                                                    </div>
                                                )
                                            })
                                        }
                                    </>
                                    : <>
                                        <div className={this.props.classes.Activities}> {this.t('activities')} </div>
                                        <Editor
                                            handleChange={(_value) => {
                                                const text = this.editor?.state?.text !== '<p><br></p>' ? this.editor?.state?.text : ''
                                                this.setState({
                                                    activitySetting: {
                                                        ...this.state.activitySetting,
                                                        [this.state.redPacketSelectTitle]: text
                                                    }
                                                })
                                            }}
                                            onRef={(ref) => (this.editor = ref)}
                                        />
                                    </>
                            }
                        </Grid>
                    )}
                    {isTigerBoadrd && (
                        <React.Fragment>
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField2}
                                        label={this.t('dragonThreshold')}
                                        value={this.state.dragonThreshold}
                                        onChange={(event) => {
                                            const val = parseInt(event.target.value)
                                            this.setState({
                                                dragonThreshold: val || 0,
                                            })
                                        }}
                                        error={this.state.valid && this.state.dragonThreshold <= 0}
                                        helperText={this.state.valid && this.state.dragonThreshold <= 0 ? `${this.t('Event.validationMsg.thresholdCannotLessThan')} 0` : ''}
                                        InputProps={{
                                            endAdornment: <InputAdornment position="end">{this.t('gameCurrency')}</InputAdornment>,
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField2}
                                        readOnly
                                        label={`${this.t('totalMoney')}(${this.t('gameCurrency')})`}
                                        value={
                                            this.state.dragonTableData.length > 0
                                                ? this.state.dragonTableData
                                                    .map((elem) => elem.money)
                                                    .reduce((accumulator, currentValue) => accumulator + currentValue)
                                                : 0
                                        }
                                    />
                                </Grid>
                                <MaterialTable
                                    style={{ marginLeft: '10px' }}
                                    columns={this.dragonTigerBoardTableColumns}
                                    data={this.state.dragonTableData}
                                    options={{
                                        showTitle: true,
                                        selection: true,
                                        search: false,
                                        pageSize: 7,
                                        pageSizeOptions: [],
                                    }}
                                    actions={[{
                                        text: '',
                                        icon: 'add_box',
                                        isFreeAction: true,
                                        onClick: () => {
                                            this.handleOpenDragonTigerDialog('add', 'dragon')
                                        }
                                    }, ...this.actions]}
                                    title={this.t('dragonBoard')}
                                    localization={{
                                        body: {
                                            emptyDataSourceMessage: ''
                                        },
                                        pagination: {
                                            firstTooltip: '',
                                            previousTooltip: '',
                                            nextTooltip: '',
                                            labelDisplayedRows: '{from}-{to} / {count}',
                                            lastTooltip: '',
                                        },
                                    }}
                                />
                            </Grid>
                            <Grid item xs={4}>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField2}
                                        label={this.t('tigerThreshold')}
                                        value={this.state.tigerThreshold}
                                        onChange={(event) => {
                                            const val = parseInt(event.target.value)
                                            this.setState({
                                                tigerThreshold: val || 0,
                                            })
                                        }}
                                        error={this.state.valid && this.state.tigerThreshold <= 0}
                                        helperText={this.state.valid && this.state.tigerThreshold <= 0 ? `${this.t('Event.validationMsg.thresholdCannotLessThan')} 0` : ''}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField
                                        className={this.props.classes.textField2}
                                        readOnly
                                        label={`${this.t('totalMoney')}(${this.t('gameCurrency')})`}
                                        value={
                                            this.state.tigerTableData.length > 0
                                                ? this.state.tigerTableData
                                                    .map((elem) => elem.money)
                                                    .reduce((accumulator, currentValue) => accumulator + currentValue)
                                                : 0
                                        }
                                    />
                                </Grid>
                                <MaterialTable
                                    style={{ marginLeft: '10px' }}
                                    columns={this.dragonTigerBoardTableColumns}
                                    data={this.state.tigerTableData}
                                    options={{
                                        showTitle: true,
                                        selection: true,
                                        search: false,
                                        pageSize: 7,
                                        pageSizeOptions: [],
                                    }}
                                    actions={[{
                                        text: '',
                                        icon: 'add_box',
                                        isFreeAction: true,
                                        onClick: () => {
                                            this.handleOpenDragonTigerDialog('add', 'tiger')
                                        }
                                    }, ...this.actions]}
                                    title={this.t('tigerBoard')}
                                    localization={{
                                        body: {
                                            emptyDataSourceMessage: ''
                                        },
                                        pagination: {
                                            firstTooltip: '',
                                            previousTooltip: '',
                                            nextTooltip: '',
                                            labelDisplayedRows: '{from}-{to} / {count}',
                                            lastTooltip: '',
                                        },
                                    }}
                                />
                            </Grid>
                        </React.Fragment>
                    )}
                    {
                        this.state.dragonTigerEditDialog &&
                        <EventDragonTigerAwardsDialog
                            dialogType={this.state.dragonTigerEditDialogType}
                            type={this.state.dragonTigerEditType}
                            data={this.state.dragonTigerEditData}
                            closeDialog={() => {
                                this.setState({
                                    dragonTigerEditDialog: false
                                })
                            }}
                            confirm={(amount, count) => {
                                this.handleDragonTigerAwards(amount, count)
                            }}
                        />
                    }
                    {isFreeGame && <Grid item xs={8}>
                        <GiveFreeGame
                            onRef={(ref) => (this.gfGame = ref)}
                            data={this.state.eventInfo}
                            dialogType={this.state.dialogType}
                        />
                    </Grid>}
                </Grid>
                <ConfirmMsgDialog onRef={(ref) => (this.confirmDialog = ref)} />
                <UploadActivityImgDialog
                    confirmCallback={() => {
                        this.setState({
                            redPacketImageData: { ...this.state.redPacketImageData, ...this.UploadActivityImgDialog.state.imageData }
                        })
                    }}
                    onRef={(ref) => {
                        this.UploadActivityImgDialog = ref
                    }}
                />
            </Modal>
        )
    }
}

const styles = (theme) => {
    return {
        select: {
            margin: theme.spacing(1),
            width: '150px',
        },
        textField: {
            margin: theme.spacing(1),
            width: '150px',
            '& p': {
                whiteSpace: 'nowrap',
            }
        },
        textField2: {
            margin: theme.spacing(1),
            width: '175px',
            '& p': {
                whiteSpace: 'nowrap',
            }
        },
        actionsBtn: {
            cursor: 'pointer',
            marginLeft: 10,
            marginRight: 10,
            '&:hover': {
                opacity: '0.7'
            }
        },
        loadingIcon: {
            marginRight: theme.spacing(1),
            color: '#fff',
            lineHeight: 1
        },
        activityBtn: {
            fontSize: '17px',
            marginRight: '15px'
        },
        activityBtnList: {
            display: 'flex', 
        },
        timeBar: {
            paddingTop: '5px',
            display: 'flex'
        },
        localTime: {
            height: '100%',
            justifyContent: 'center',
            alignItems: 'start',
            display: 'flex',
            flexDirection: 'column',
            paddingRight: '30px',
            paddingLeft: theme.spacing(1)
        },
        redPacketActionCol: {
            display: 'flex',
            justifyContent: 'center'
        }
        ,
        redPacketActionBtn: {
            paddingRight: '10px',
            cursor: 'pointer',
            color: '#69131C',
            fontSize: '20px',

        },
        redPacketInput: {
            width: '100%',
        },
        flexCenter: {},
        redPacketRemove: {
            cursor: 'pointer',
            display: 'flex',
            alignItems: 'center',
            paddingLeft: '11px'
        },
        Activities: {
            paddingTop: '10px',
            paddingBottom: '10px',
            fontSize: '20px',
            fontWeight: '700'
        }
    }
}

EventDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EventDialog)
